<template>
    <section class="section-style text-center bg-white pb-1">
        <div class=""
             data-aos="fade-right"
             data-aos-offset="100"
             data-aos-once="true"
             data-aos-duration="500">
            <h2 class="bd-title section-title default-letter-spacing text-uppercase font-weight-bold font-md">Our Programs</h2>

            <div class="row">

    			<a class="col-lg section-style text-decoration-none transi" style="background: #b79254; margin: 2px 2px 0; display: flex;" href="https://oo.ultimatejetvacations.com/optin1664901558257">
                    <div class="align-middle mx-auto" style="align-items: center; justify-content: center; display: grid; align-content: center;">
                        <h2 class="text-uppercase font-lg white pt-4 pb-4 my-3"><span class="text-dark">CANCEL FOR ANY REASON</span><br><span class="">INSURANCE</span></h2>
                    </div>
    			</a>
    		</div>

        </div>
    </section>
</template>

<script>

    import AOS from 'aos';
    import 'aos/dist/aos.css';

    AOS.init();

    export default {
        mounted() {

        }
    }

</script>

<style lang="scss" type="text/scss">
    .transi {
        transition: .5s ease all !important;
    }
    .transi:hover {
        opacity: .8;
    }
    .widthcien {
        width: 100%;
    }
</style>
